import {css} from '@emotion/css';
import React, {HTMLAttributes} from 'react';
import {theme} from './Common';
import {Modal} from './Modal';

export type CustomerPortalModalConfirmedProps = {
  title?: string;
  isOpen: boolean;
  setIsOpen: (value: boolean) => unknown;
  children: React.ReactNode;
};

export const CustomerPortalModalConfirmed = ({
  title,
  isOpen,
  setIsOpen,
  children,
}: CustomerPortalModalConfirmedProps) => (
  <Modal title={title || 'Confirmed'} isOpen={isOpen} setModal={setIsOpen}>
    <Content>
      <Title>{children}</Title>
    </Content>
  </Modal>
);
const Content = (args: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    })}
    {...args}
  />
);
const Title = (args: HTMLAttributes<HTMLParagraphElement>) => (
  <p
    className={css({
      color: theme.colors.darkGray,
      fontSize: theme.font.sizes.medium,
      fontFamily: theme.font.family,
      fontWeight: theme.font.bold,
      textAlign: 'center',
    })}
    {...args}
  />
);
